var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cen"},[_c('ul',{staticClass:"create_ul"},[_c('li',{staticClass:"li3",on:{"click":_vm.add}},[_c('img',{attrs:{"src":require("../assets/images/add.png")}}),_c('p',[_vm._v("创建学生")])]),_vm._l((_vm.createList),function(item,index){return _c('div',{key:'li2' + index},[(
          item.state != 0 &&
          item.state != 1 &&
          item.state != 2 &&
          (item.step == 1 ||
            item.step == 2 ||
            item.step == 3 ||
            item.step == 4 ||
            item.step == 5)
        )?_c('li',{staticClass:"li2"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.state !== 3),expression:"item.state !== 3"}],staticClass:"span2",attrs:{"src":require("../assets/images/del.png")},on:{"click":function($event){return _vm.deletelists(item.id)}}}),_c('p',{on:{"click":function($event){return _vm.tiao(
              item.step,
              item.id,
              item.studentIdCard,
              item.enrollmentGrade,
              item.mold
            )}}},[_c('span',{staticStyle:{"color":"#0f9386","display":"inline","font-size":"0.72rem"}},[_vm._v(_vm._s(item.studentName))]),_vm._v("信息待提交 ")]),_c('span',{on:{"click":function($event){return _vm.tiao(
              item.step,
              item.id,
              item.studentIdCard,
              item.enrollmentGrade,
              item.mold,
              item.propertyType,
              item.propertyRelationship,
              item.sameActual
            )}}},[_vm._v("继续完善信息")])]):_vm._e()])}),_vm._l((_vm.createList),function(item,index){return _c('div',{key:index},[(item.state != 3)?_c('li',{staticClass:"li1"},[_c('p',{on:{"click":function($event){return _vm.examine(
              item.studentName,
              item.id,
              item.state,
              item.enrollmentGrade,
              item.studentIdCard
            )}}},[_vm._v(" 学生姓名："+_vm._s(item.studentName)+" "),(item.state == 0)?_c('span',{staticStyle:{"color":"orange"}},[_vm._v("（正在审核）")]):_vm._e(),(item.state == 1)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("（审核已经完成）")]):(item.state == 2)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("（未通过）")]):_vm._e()]),_c('p',{on:{"click":function($event){return _vm.examine(
              item.studentName,
              item.id,
              item.state,
              item.enrollmentGrade,
              item.studentIdCard
            )}}},[_vm._v(" 身份证号："+_vm._s(item.studentIdCard)+" ")]),_c('p',[_vm._v("报名学校："+_vm._s(item.schoolName))]),(item.state == 1)?_c('p',[_vm._v("录取学校："+_vm._s(item.admittedSchools))]):_vm._e(),_c('img',{attrs:{"src":require("../assets/images/into.png"),"alt":""},on:{"click":function($event){return _vm.examine(
              item.studentName,
              item.id,
              item.state,
              item.enrollmentGrade,
              item.studentIdCard
            )}}})]):_vm._e()])})],2),_c('notices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }